import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import Header from "../components/header";
import { AppShell } from "@mantine/core";
// import Footer from "../components/footer";

export const Route = createRootRoute({
  component: () => (
    <>
      <AppShell header={{ height: 76 }} footer={{ height: 84 }}>
        <Header />
        <AppShell.Main bg="var(--wallet-color-sambla-red-shade-200)">
          {/* <ScrollArea
            h="calc(100vh - var(--app-shell-header-height, 0px) - var(--app-shell-footer-height, 0px))"
            scrollbars="y"
            px="1rem"
            style={{
              backgroundImage: "url(./slide-bg.svg)",
              backgroundSize: "145%",
              backgroundPosition: "bottom left",
              backgroundRepeat: "no-repeat",
              backgroundPositionX: "-160px",
            }}
          >
          </ScrollArea> */}
          <Outlet />
        </AppShell.Main>

        {/* <Footer /> */}
      </AppShell>

      {import.meta.env.dev && <TanStackRouterDevtools />}
    </>
  ),
});
